<template>
  <div>
    <div class="flex items-center justify-between">
      <h2 class="font-bold text-18px pb-0.5">Assets</h2>
      <ElButton
        v-if="
          sets.length > 0 &&
          [0, 1].includes(this.flight.status) &&
          ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) &&
          !$is_PM &&
          !$is_GD
        "
        type="primary"
        size="small"
        icon="el-icon-plus"
        class="mb-1"
        plain
        @click="addAssets"
        >Add assets</ElButton
      >
    </div>
    <el-switch class="mb-1" v-model="allCollapse" active-text="Expand" inactive-text="Collapse"> </el-switch>
    <template v-if="sets.length > 0">
      <CardCollapse v-for="(set, index) in sets" :key="index" class="assets-form" :title="set.name" icon="doc" :isOpen="allCollapse">
        <template slot="title-action">
          <AssetActionMenu v-if="[0, 1].includes(flight.status)" :asset="set" :is-simple="campaign?.is_simple" />
        </template>
        <!-- media section -->
        <div class="pl-4 mb-2">
          <div class="font-bold pb-0.5">Media</div>
          <template v-if="!set?.post_url">
            <AssetCard
              v-for="(media, index) in parse_file(set.media_file)"
              :key="index"
              :noImg="media.thumbnail_url === null || media.url === null"
              :content="{ type: 'image', size: media.size, name: media.name, url: media.thumbnail_url, id: media.id }"
            />
          </template>
          <template v-else>
            <AssetCard icon="slim-link" :content="{ type: 'link', url: set.post_url }" />
          </template>
        </div>
        <!-- end -->
        <!-- landing page section -->
        <div v-if="set?.landing_page" class="pl-4 mb-2">
          <div class="font-bold pb-0.5">Landing Page</div>
          <AssetCard icon="slim-link" :content="{ type: 'link', url: set.landing_page }" />
        </div>
        <!-- end -->
        <!-- CTA section -->
        <div v-if="set?.cta_color && set?.cta_text" class="pl-4 mb-2">
          <div class="font-bold pb-0.5">Call to Action</div>
          <AssetCard :content="{ type: 'ctaColor', color: set.cta_color }" />
          <AssetCard icon="text-cursor" :content="{ type: 'ctaText', text: set.cta_text }" />
        </div>
        <!-- end -->
        <div v-if="set?.tracking_tags" class="pl-4 mb-2">
          <div class="font-bold pb-0.5">UTMs (Tracking)</div>
          <AssetCard
            v-for="(tag, index) in parse_file(set.tracking_tags)"
            icon="doc"
            :key="index"
            :content="{
              type: 'utm',
              size: tag.size,
              name: tag.name,
              url: tag.path,
              id: tag.id,
            }"
          />
        </div>
        <!-- end -->
      </CardCollapse>
    </template>
    <NoDataCard v-else>
      <template slot="title">No assets yet</template>
      <template v-if="($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM && !$is_GD" slot="info">
        <p>Start adding assets to set up this flight</p>
        <ElButton type="primary" size="small" icon="el-icon-plus" class="mt-2" plain @click="addAssets">Add assets</ElButton>
      </template>
    </NoDataCard>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CardCollapse from '@/components/social-products/social-boost/parts/CardCollapse.vue'
import AssetItem from '@/components/social-products/social-boost/forms/AssetItem.vue'
import AssetCard from '@/components/social-products/social-boost/parts/AssetCard.vue'
import NoDataCard from '@/components/social-products/social-boost/parts/NoDataCard.vue'
import AssetActionMenu from '@/components/social-products/social-boost/parts/AssetActionMenu.vue'

export default {
  components: {
    CardCollapse,
    AssetItem,
    AssetCard,
    NoDataCard,
    AssetActionMenu,
  },
  data() {
    return {
      isEdit: false,
      allCollapse: false,
      assetGroup: {
        assets: {},
        isOpen: true,
        name: 'Assets',
      },
    }
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign', 'isLoadingPage']),
    flight() {
      return this.campaign?.flights?.find((f) => f.id === Number(this.$route.params.flight_id))
    },
    sets() {
      return this.flight?.assets || []
    },
    is_view_flight() {
      return this.$route?.meta?.section === 'view-flight'
    },
  },
  methods: {
    parse_file(value) {
      return value
    },
    addAssets() {
      this.$router.push({
        name: 'social-boost-add-assets',
        params: { id: this.$route.params.id, flight_id: this.$route.params.flight_id },
        query: { redirect: this.$route.name },
      })
    },
  },
}
</script>
